import * as React from "react";
import { Pagination, PaginationOptions, PaginationTotalCount } from "@bolteu/kalep-react";
import { cx } from "../utils/cx";
export function TablePagination({ totalItems, count, currentPage, rowsPerPage, showTotalCount = true, rowsPerPageOptions, onPaginationChange, }) {
    const shouldShowRowOptions = rowsPerPageOptions && rowsPerPageOptions.length !== 1;
    const onPageChange = React.useCallback((page) => onPaginationChange(page, rowsPerPage), [rowsPerPage, onPaginationChange]);
    const onRowsPerPageChange = React.useCallback((rows) => {
        // For example
        // you are on page 2 with 25 elements and now you want to switch to 50 elements
        // effectively to see the same content you should go to the page 1. because you saw elements between (25, 50), now you should see
        // elements between (0,50) (because 25 is not an option anymore)
        //
        // Alternatively if you are on page 1 and see content between (0, 50) and you want to switch to 25 elements, you should see elements
        // between (0, 25)
        //
        // to keep the starting number the same, we need to understand following logic
        // (old_rows_per_page * page_number, old_rows_per_page * (page_number + 1) is the current view
        //  we want to turn it into
        // (new_rows_per_page * new_page_number, new_rows_per_page * (new_page_number + 1) is the new view
        //
        // which gives us the formula old_rows_per_page * page_number = new_rows_per_page * new_page_number
        // new_page_number = old_rows_per_page * page_number / new_rows_per_page
        //
        // Now if old_rows_per_page / new_rows_per page is not an even number.
        // If we round up
        //  - (we always end up at least next page because old_rows_per_page / new_rows_per_page > 0)
        // If we round down
        // - (we end up up some or next page) <-- behaviour we want
        const newPageNumber = Math.floor((currentPage * rowsPerPage) / rows);
        onPaginationChange(newPageNumber, rows);
    }, [currentPage, rowsPerPage, onPaginationChange]);
    return (React.createElement("footer", { className: cx("mt-6 mb-8 w-full gap-6 flex flex-wrap items-center justify-center sm:flex-row-reverse sm:justify-between sm:[&>*]:w-auto") },
        React.createElement(Pagination, { "aria-label": "Pagination for the table above", count: count, currentPage: currentPage, onClick: onPageChange }),
        showTotalCount && (React.createElement(PaginationTotalCount, { currentPage: currentPage, rowsPerPage: rowsPerPage, totalItems: totalItems })),
        shouldShowRowOptions && (React.createElement(PaginationOptions, { value: rowsPerPage, options: rowsPerPageOptions, onChange: onRowsPerPageChange }))));
}
